import { Routes, Route, BrowserRouter } from "react-router-dom";
import Inicio from "../pages/Inicio";
import Contact from "../pages/Contact/Contact";
import Specialties from "../pages/Specialties";
import CourseDetails from "../pages/CourseDetails";
import CoursesPage from "../pages/CoursesPage/CoursesPage";
import AboutUsPage from "../pages/AboutUs/AboutUsPage";
import CoursePaymentPage from "../pages/CoursePaymentPage/CoursePaymentPage";
import PaymentCheckout from "../pages/PaymentCheckout/PaymentCheckout";
import TransferBankPage from "../pages/TransferBankPage/TransferBankPage";
import { ScrollToTop } from 'react-router-scroll-to-top';
import Error404Page from "../pages/ErrorPage/Error404Page";
import PreguntasFrecuentes from "../pages/PreguntasFrecuentes/PreguntasFrecuentes";
import Registry from "../pages/Campus/Registry";
import Admin from "../pages/Admin/Admin";
import EliteOffer from "../pages/EliteOffer/EliteOffer";
import BlogPage from "../pages/Blog/BlogPage";
import BlogDetails from "../pages/BlogDetails/BlogDetails";
import Catalog from "../pages/Catalog/Catalog";
import Subscription from "../pages/Subscription/Subscription";
import GrandPage from "../pages/Grand/GrandPage";
import Sorteo from "../pages/Sorteo/Sorteo";
import { ROUTES_PATHNAME } from "./dict";
import PersonPage from "../pages/PersonPage/PersonPage";
import TermsAndConditionsPage from "../pages/TermsAndConditionsPage/TermsAndConditionsPage";
import MainLayout from "../layouts/MainLayout/MainLayout";
import InteractiveMapAndChart from "../features/Inicio/InteractiveMapAndChart/InteractiveMapAndChart";
import CancelSubscription from "../pages/CancelSubscription/CancelSubscription";

const AppRoutes = () => {
   return (
      <>
         <BrowserRouter>
            <ScrollToTop />
            <Routes>

               <Route exact path="/" element={<Inicio />} />  
               <Route exact path="/mapa" element={
                  <MainLayout>
                     <InteractiveMapAndChart padding={`0 32px`} />
                  </MainLayout>
               }
               />  
               <Route exact path="/catalogo" element={<Catalog />} />  
               <Route path="/institucional" element={<AboutUsPage />} /> 
               <Route path="/contacto" element={<Contact />} />  
               <Route
                  path="/especializaciones/:specialtyId"
                  element={<Specialties />}
               />
               <Route path={ROUTES_PATHNAME.courses.href} element={<CoursesPage />} /> 
               <Route path={`${ROUTES_PATHNAME.courses.href}/:id`} element={<CourseDetails />} /> 
               <Route path={'/cursos'} element={<CoursesPage />} />  
               <Route path={`/curso/:id`} element={<CourseDetails />} />  


               <Route path="/procesando-pago/" element={<PaymentCheckout />} /> 
               <Route path="/pago" element={<CoursePaymentPage />} />  
               <Route path="/preguntas-frecuentes" element={<PreguntasFrecuentes />} /> 

               <Route path="/transferencia-bancaria" element={<TransferBankPage />} /> 

               <Route path="/campus" element={<Registry />} /> 
               <Route path="/admin" element={<Admin />} />  
               <Route path="/oferta-elite" element={<EliteOffer />} />  
               <Route path="/comunidad" element={<Subscription />} /> 

               <Route path="/desactivar" element={<CancelSubscription />} />

               <Route path="/profesores/:name" element={<PersonPage />} />  

               <Route path="/sorteo/:slug" element={<Sorteo />} /> 
               <Route path="/terminos-y-condiciones" element={<TermsAndConditionsPage />} /> 

               <Route path="/grand" element={<GrandPage />} />  
               <Route path={`/grand${ROUTES_PATHNAME.courses.href}/:id`} element={<CourseDetails isGrand />} />  
               <Route path="/grand/curso/:id" element={<CourseDetails isGrand />} />  

               <Route exact path="/grand/catalogo" element={<Catalog isGrand />} />  


               <Route path="/grand/pago" element={<CoursePaymentPage isGrand />} />  
               <Route path="/grand/transferencia-bancaria" element={<TransferBankPage isGrand />} />  
               <Route path="*" element={<Error404Page />} />  
               <Route path="/blog" element={<BlogPage />} />  
               <Route path="/blog/:slugName" element={<BlogDetails />} />  

            </Routes>
         </BrowserRouter>
      </>
   );
};
export default AppRoutes;
